import { axiosInstance } from '../Middleware'
import { ResponseGetAllType } from '../response';
import { CollectiviteType, LiensEsagType } from './types'

export class CollectiviteApi {
  public static loadCollectivite = (complement?: string) : Promise<ResponseGetAllType<CollectiviteType>> =>
 axiosInstance.get(`/personnel/personnel/collectivites${complement ? `?${complement}` : ''}`)
      .then(response => response.data);
  public static loadLiensEsag = (identifiantEntite: number) : Promise<ResponseGetAllType<LiensEsagType>> =>
  axiosInstance.get(`/personnel/personnel/liensesag?identifiantEntite=${identifiantEntite}`)
      .then(response => response.data);
}
